// extracted by css-extract-rspack-plugin
export default {"successText":"AuthSuccessText_successText__mM3cx","signInLink":"AuthSuccessText_signInLink__EuxJ3","signInButtonWrapper":"AuthSuccessText_signInButtonWrapper__bVXlv"};